import { SelectContent } from '../ui/select';
import { cn } from '@/lib/utils';
import { useClinicalFontScale } from './ClinicalFontScaleContext';

export default function ClinicalSelectContent({ className, style, ...props }) {
  const scale = useClinicalFontScale();
  return (
    <SelectContent
      className={cn('clinical-form-select-content', className)}
      style={{
        ...style,
        fontSize: `calc(0.875rem * ${scale})`,
      }}
      {...props}
    />
  );
}
